import { useEffect, useState } from "react";
import Job from "../../models/Job";
import Modal from "../../../../../components/base/Modal";
import { deleteJobClose, getCountry, getUSA, reloadAfterDelete, useEnvironment, useHub } from "../../../../../core/Global";
import { API_ROUTES } from "../../../../../core/Constants";
import Map from "../../../../../components/here/Map";
import AddressField from "../../../../../components/here/AddressField";
import { HereGeocodeItem } from "../../../../../models/MapModels";
import TextBox from "../../../../../components/form/TextBox";
import Country from "../../../../base/models/Country";
import DropDown from "../../../../../components/form/DropDown";
import DateItem from "../../../../../models/DateItem";
import { toastError, toastSuccess } from "../../../../../components/base/Toast";

interface IProps {
    job?: Job
    onClose?: () => void
}
export default function JobDeleteModal(props: IProps) {

    const hub = useHub();
    const env = useEnvironment();



    return (
        <Modal id="modal-job-delete"
            title="Delete Job"
            subtitle={"Job ID: #" + props.job?.jobId + " | " + props.job?.fullName}
            buttonText="Confirm & Delete Job"
            buttonColor="danger"
            visible open
            onClose={() => deleteJobClose()}
            onConfirm={callback => {

                hub.Post(API_ROUTES.Jobs + "deletejob", {
                    id: props.job?.id,
                }, res => {
                    if (res.success) toastSuccess("Job has been deleted successfully!")
                    callback(!res.success)
                    reloadAfterDelete()
                })

            }}
        // secondActionText="Cancel Instead"
        // secondActionColor="warning"
        // onSecondConfirm={callback => {

        // }}
        >

            <div>
                <div className="mb-5">
                    This job will be permanently removed and cannot be restored. Do you want to continue?
                </div>
                <div className="alert alert-danger">
                    <div className="mb-1">
                        #{props.job?.jobId}
                    </div>
                    <div className="mb-1">
                        {props.job?.phone?.phoneFriendly}
                    </div>
                    <div>
                        {props.job?.address?.title}
                    </div>
                </div>
            </div>

        </Modal>
    )

}